import script from "./SpendingMap.vue?vue&type=script&setup=true&lang=js"
export * from "./SpendingMap.vue?vue&type=script&setup=true&lang=js"

import "./SpendingMap.vue?vue&type=style&index=0&id=7650aa64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7650aa64"]])

export default __exports__